<template>
<div class="chapter">
<div class="inner_page">
<div class="fs" id="page019">
<div class="jstfy" id="page019_1">5.</div>
<div class="jstfy" id="page019_1a"><span class="page019_1a">Roll out the dough into a 30-cm-diameter circle. Cut the circle</span></div>
<div class="jstfy" id="page019_2">into 8 wedges (like pizza slices). Put 1 teaspoon of apricot jam in</div>
<div class="jstfy" id="page019_3">the centre of a wedge and roll it up from the bottom, turning the</div>
<div class="jstfy" id="page019_4">pointed sides slightly inwards. Tuck the end under the croissant,</div>
<div class="jstfy" id="page019_5">pressing firmly, to prevent it from coming loose while baking.</div>
<div class="jstfy" id="page019_6">Rest the croissants 2-3 hours on a baking tray lined with baking</div>
<div class="jstfy" id="page019_7">parchment.</div>
<div class="jstfy" id="page019_8">6.</div>
<div class="jstfy" id="page019_8a"><span class="page019_8a"> Preheat the oven to 180°C/350°F/gas 4. Brush the croissants</span></div>
<div class="jstfy" id="page019_9">with a little vegan cream to give them a nice golden colour when</div>
<div class="jstfy" id="page019_10">baked. Bake for 20–25 minutes on the middle shelf, until golden.</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// page_019.vue?3ce0548e